<div class="page-wrapper supplier-detail-page">
    <div class="wrap-breadcrumb">
        <div class="container">
            <div class="breadcrumb">
                <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
            </div>
        </div>
    </div>
    <div class="supplier-detail-page-inner">
        <div class="container">
            <div class="wrap-title d-flex align-items-center">
                <img [src]="logo" alt="logo" />
                <div>
                    <h2 class="title-company mb-0">{{ detailSupplier?.companyName }}</h2>
                    <button (click)="goCatalogue(detailSupplier)" class="btn-common btn-catalogue">
                        {{ 'export.CATALOGUE' | translate | uppercase }}
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="info-general d-flex">
                <div class="wrap-content">
                    <div
                        *ngIf="
                            detailSupplier?.siret ||
                            detailSupplier?.vat ||
                            detailSupplier?.nafCode ||
                            detailSupplier?.phone ||
                            detailSupplier?.email ||
                            detailSupplier?.address ||
                            detailSupplier?.postcode ||
                            detailSupplier?.city ||
                            detailSupplier?.country?.labels?.fr_FR ||
                            detailSupplier?.fax ||
                            detailSupplier?.website
                        "
                        class="d-flex justify-content-between"
                        style="min-width: 60%"
                    >
                        <div
                            *ngIf="
                                detailSupplier?.siret ||
                                detailSupplier?.vat ||
                                detailSupplier?.nafCode
                            "
                            class="block-left"
                        >
                            <p *ngIf="detailSupplier?.siret">
                                {{ 'IRONSIDE.supplier-detail.SIRET' | translate }} :
                                <span>{{ detailSupplier?.siret || '__' }}</span>
                            </p>
                            <p *ngIf="detailSupplier?.vat">
                                {{ 'IRONSIDE.supplier-detail.VAT' | translate }} :
                                <span>{{ detailSupplier?.vat || '__' }}</span>
                            </p>
                            <p *ngIf="detailSupplier?.nafCode">
                                {{ 'IRONSIDE.supplier-detail.NAF_Code' | translate }} :
                                <span>{{ detailSupplier?.nafCode || '__' }}</span>
                            </p>
                        </div>
                        <div
                            *ngIf="
                                detailSupplier?.phone ||
                                detailSupplier?.email ||
                                detailSupplier?.address ||
                                detailSupplier?.postcode ||
                                detailSupplier?.city ||
                                detailSupplier?.country?.labels?.fr_FR ||
                                detailSupplier?.fax ||
                                detailSupplier?.website
                            "
                            class="block-right"
                        >
                            <h3 class="title-section">
                                {{ 'IRONSIDE.supplier-detail.CONTACT_DETAILS' | translate }}
                            </h3>
                            <div class="group-info-general">
                                <div *ngIf="detailSupplier?.phone">
                                    <p>{{ 'IRONSIDE.supplier-detail.PHONE' | translate }} :</p>
                                    <a href="tel:{{ detailSupplier?.phone }}">{{
                                        detailSupplier?.phone
                                    }}</a>
                                </div>

                                <div *ngIf="detailSupplier?.email">
                                    <p>{{ 'IRONSIDE.supplier-detail.EMAIL' | translate }} :</p>

                                    <a href="mailto:{{ detailSupplier?.email }}">{{
                                        detailSupplier?.email
                                    }}</a>
                                </div>

                                <div
                                    *ngIf="
                                        detailSupplier?.address &&
                                        detailSupplier?.postcode &&
                                        detailSupplier?.city &&
                                        detailSupplier?.country?.labels?.fr_FR
                                    "
                                >
                                    <div class="address">
                                        <p>
                                            {{ 'IRONSIDE.supplier-detail.ADDRESS' | translate }} :
                                        </p>
                                        <span>{{ getFormattedAddress(detailSupplier) }} </span>
                                    </div>
                                </div>

                                <div *ngIf="detailSupplier?.fax" class="fax">
                                    <p>{{ 'IRONSIDE.supplier-detail.FAX' | translate }} :</p>
                                    <a href="tel:{{ detailSupplier?.fax }}"
                                        >+{{ detailSupplier?.fax }}</a
                                    >
                                </div>
                                <div class="website" *ngIf="detailSupplier?.website">
                                    <p>{{ 'IRONSIDE.supplier-detail.WEBSITE' | translate }} :</p>

                                    <a
                                        style="font-size: 12px"
                                        href="{{ detailSupplier?.website }}"
                                        >{{ detailSupplier?.website }}</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="section-conditions"
                        *ngIf="
                            detailSupplier?.termsOfPayment?.en_GB ||
                            detailSupplier?.afterSalesService?.en_GB ||
                            detailSupplier?.minimumOrderValue?.en_GB ||
                            detailSupplier?.supplyQuota?.en_GB ||
                            detailSupplier?.deliveryTimes?.en_GB ||
                            detailSupplier?.lastPriceUpdate?.length > 0
                        "
                    >
                        <h3 class="title-section">
                            {{ 'IRONSIDE.supplier-detail.conditions' | translate }}
                        </h3>
                        <div class="item-conditions">
                            <div *ngIf="detailSupplier?.termsOfPayment?.en_GB">
                                <p>{{ 'IRONSIDE.supplier-detail.payment_terms' | translate }} :</p>
                                <span>
                                    {{ detailSupplier?.termsOfPayment | translateDynamicLanguage }}
                                </span>
                            </div>

                            <div *ngIf="detailSupplier?.afterSalesService?.en_GB">
                                <p>
                                    {{ 'IRONSIDE.supplier-detail.after_sales_service' | translate }}
                                    :
                                </p>
                                <span>
                                    {{
                                        detailSupplier?.afterSalesService | translateDynamicLanguage
                                    }}
                                </span>
                            </div>

                            <div *ngIf="detailSupplier?.minimumOrderValue?.en_GB">
                                <p>
                                    {{ 'IRONSIDE.supplier-detail.minimum_order_value' | translate }}
                                    :
                                </p>
                                <span>
                                    {{
                                        detailSupplier?.minimumOrderValue | translateDynamicLanguage
                                    }}
                                </span>
                            </div>

                            <div *ngIf="detailSupplier?.supplyQuota?.en_GB">
                                <p>{{ 'IRONSIDE.supplier-detail.supply_quota' | translate }} :</p>
                                <span>
                                    {{ detailSupplier?.supplyQuota | translateDynamicLanguage }}
                                </span>
                            </div>

                            <div *ngIf="detailSupplier?.deliveryTimes?.en_GB">
                                <p>{{ 'IRONSIDE.supplier-detail.delivery_times' | translate }} :</p>
                                <span>
                                    {{ detailSupplier?.deliveryTimes | translateDynamicLanguage }}
                                </span>
                            </div>

                            <div *ngIf="detailSupplier?.lastPriceUpdate">
                                <p>
                                    {{ 'IRONSIDE.supplier-detail.last_price_update' | translate }} :
                                </p>
                                <span>
                                    {{ detailSupplier?.lastPriceUpdate | date : 'dd/MM/yyyy' }}
                                </span>
                            </div>

                            <div *ngIf="detailSupplier?.validityUpTo">
                                <p>{{ 'IRONSIDE.supplier-detail.validity_up_to' | translate }} :</p>
                                <span>
                                    {{ detailSupplier?.validityUpTo | translateDynamicLanguage }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div
                        class="section-billing"
                        *ngIf="
                            detailSupplier?.structure ||
                            detailSupplier?.bankNumber ||
                            detailSupplier?.iban ||
                            detailSupplier?.swift ||
                            detailSupplier?.currency?.labels ||
                            detailSupplier?.ironsideBillingCurrency?.labels
                        "
                    >
                        <h3 class="title-section">
                            {{ 'IRONSIDE.supplier-detail.Billing' | translate }}
                        </h3>
                        <div class="d-flex flex-wrap justify-content-between">
                            <div *ngIf="detailSupplier?.structure">
                                <p>{{ 'IRONSIDE.supplier-detail.Structure' | translate }} :</p>
                                <span>{{
                                    detailSupplier?.structure?.labels | translateDynamicLanguage
                                }}</span>
                            </div>

                            <div *ngIf="detailSupplier?.bankNumber">
                                <p>{{ 'IRONSIDE.supplier-detail.Bank_Number' | translate }} :</p>
                                <span>{{ detailSupplier?.bankNumber || '__' }}</span>
                            </div>

                            <div *ngIf="detailSupplier?.iban">
                                <p>{{ 'IRONSIDE.supplier-detail.IBAN' | translate }} :</p>
                                <span>{{ detailSupplier?.iban || '__' }}</span>
                            </div>

                            <div *ngIf="detailSupplier?.swift">
                                <p>{{ 'IRONSIDE.supplier-detail.SWIFT' | translate }} :</p>
                                <span>{{ detailSupplier?.swift || '__' }}</span>
                            </div>

                            <div *ngIf="detailSupplier?.currency?.labels">
                                <p>{{ 'IRONSIDE.supplier-detail.Currency' | translate }} :</p>
                                <span>{{
                                    detailSupplier?.currency?.labels | translateDynamicLanguage
                                }}</span>
                            </div>

                            <div *ngIf="detailSupplier?.ironsideBillingCurrency?.labels">
                                <p>
                                    {{ 'IRONSIDE.supplier-detail.Ironside_Currency' | translate }} :
                                </p>
                                <span>{{
                                    detailSupplier?.ironsideBillingCurrency?.labels
                                        | translateDynamicLanguage
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="block-end"
                    *ngIf="
                        listFileSupplier.length > 0 &&
                        permissionService.isPermissionFonction('access-ressource-fournisseur')
                    "
                >
                    <h3 class="title-section">
                        {{ 'IRONSIDE.supplier-detail.ATTACHMENTS' | translate }}
                    </h3>
                    <div
                        class="d-flex flex-column justify-content-between gap-2 group-info-general group-file-general"
                    >
                        <div class="group-file d-flex flex-column gap-2 flex-wrap">
                            <div
                                [matTooltip]="item?.nameFileDetail"
                                *ngFor="let item of listFileSupplier"
                                class="wrap-file p-2"
                            >
                                <a class="" (click)="openFile(item)" target="_blank">
                                    <img src="src-ironside/assets/icons/file-text.svg" />
                                    <div class="wrap-text">
                                        <p class="mb-0 font-bold" style="font-size: 13px">
                                            {{ item?.nameFile | translateDynamicLanguage }}
                                        </p>
                                        <p class="mb-0">{{ item?.nameFileDetail }}</p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="wrap-contacts py-5" *ngIf="contactData.length > 0">
            <div class="container">
                <h3 class="title text-center">
                    {{ 'IRONSIDE.supplier-detail.CONTACTS' | translate }}
                </h3>
                <div class="wrap-table">
                    <p-table [value]="contactData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th class="font-bold" style="min-width: 180px">
                                    {{ 'IRONSIDE.supplier-detail.Job_Title' | translate }}
                                </th>
                                <th class="font-bold" style="min-width: 135px">
                                    {{ 'IRONSIDE.supplier-detail.Last_Name' | translate }}
                                </th>
                                <th class="font-bold">
                                    {{ 'IRONSIDE.supplier-detail.First_Name' | translate }}
                                </th>
                                <th class="font-bold">
                                    {{ 'IRONSIDE.supplier-detail.entity' | translate }}
                                </th>
                                <th class="font-bold">
                                    {{ 'IRONSIDE.supplier-detail.address' | translate }}
                                </th>

                                <th class="font-bold" style="min-width: 150px; max-width: 150px">
                                    {{ 'IRONSIDE.supplier-detail.PHONE' | translate }}
                                </th>
                                <th class="font-bold">
                                    {{ 'IRONSIDE.supplier-detail.Mobile' | translate }}
                                </th>
                                <th class="font-bold" style="width: 200px">
                                    {{ 'IRONSIDE.supplier-detail.EMAIL' | translate }}
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item>
                            <tr>
                                <td>
                                    {{ item?.job }}
                                </td>
                                <td>
                                    {{ item?.lastName }}
                                </td>
                                <td>
                                    {{ item?.firstName }}
                                </td>
                                <td>
                                    {{ item?.nameOfEntity }}
                                </td>

                                <td>
                                    <span>
                                        {{ getFormattedAddress(item) }}
                                    </span>
                                </td>
                                <td>
                                    <ng-container *ngIf="item?.phone">
                                        <a class="underline" href="tel:{{ item?.phone }}">{{
                                            item?.phone
                                        }}</a>
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="item?.mobile">
                                        <a class="underline" [href]="'tel:' + item?.mobile">{{
                                            item?.mobile
                                        }}</a>
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="item?.email">
                                        <a class="underline" href="mailto:{{ item?.email }}">{{
                                            item?.email
                                        }}</a>
                                    </ng-container>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>

        <div *ngIf="listNews.length > 0" class="wrap-slides bg-white py-5">
            <div class="container">
                <h3 class="title text-center">{{ 'IRONSIDE.supplier-detail.NEWS' | translate }}</h3>
                <app-slide-news [listNewsInput]="listNews"></app-slide-news>
            </div>
        </div>
        <div *ngIf="listTrainingNews.length > 0" class="wrap-slides bg-f3 py-5">
            <div class="container">
                <h3 class="title text-center">
                    {{ 'IRONSIDE.supplier-detail.Training' | translate }}
                </h3>
                <app-slide-news [listNewsInput]="listTrainingNews"></app-slide-news>
            </div>
        </div>
        <div *ngIf="listMarketingNews.length > 0" class="wrap-slides bg-white py-5">
            <div class="container">
                <h3 class="title text-center">
                    {{ 'IRONSIDE.supplier-detail.MARKETING' | translate }}
                </h3>
                <app-slide-news [listNewsInput]="listMarketingNews"></app-slide-news>
            </div>
        </div>
        <div *ngIf="listPromotionNews.length > 0" class="wrap-slides bg-f3 py-5">
            <div class="container">
                <h3 class="title text-center">
                    {{ 'IRONSIDE.supplier-detail.PROMOTIONS' | translate }}
                </h3>
                <app-slide-news [listNewsInput]="listPromotionNews"></app-slide-news>
            </div>
        </div>
    </div>
</div>

<p-dialog
    header="Fichier d'aperçu"
    [modal]="true"
    [(visible)]="visibleItem"
    [style]="{ width: '70%' }"
>
    <div class="popup-del-row">
        <div class="w-100 text-end">
            <a href="#" (click)="onDownload($event)" class="btn-common p-2">{{
                'IRONSIDE.supplier-detail.Download' | translate
            }}</a>
        </div>
        <div id="outerContainer">
            <div class="pdf-container" [ngClass]="{ loaded: pdfLoaded }">
                <pdf-viewer
                    [src]="itemPdfShow?.urlFile || ''"
                    [rotation]="0"
                    [original-size]="false"
                    [show-all]="true"
                    [fit-to-page]="false"
                    [zoom]="1"
                    [zoom-scale]="'page-width'"
                    [stick-to-page]="false"
                    [render-text]="true"
                    [external-link-target]="'blank'"
                    [autoresize]="true"
                    [show-borders]="false"
                    style="max-width: 100; width: 100%; height: 100vh"
                    (page-rendered)="pageRendered($event)"
                    (after-load-complete)="pageProgress($event)"
                ></pdf-viewer>
            </div>
        </div>
    </div>
</p-dialog>
